import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13ac0b73&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ac0b73')) {
      api.createRecord('13ac0b73', component.options)
    } else {
      api.reload('13ac0b73', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13ac0b73&", function () {
      api.rerender('13ac0b73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/install/feeInfo/index.vue"
export default component.exports